<template>
<div>

{{mamalist}}


</div>
</template>

<script>

// var uuid_device02 = '12345678'

export default {
  data: function() {
    return {
      mamalist: {}
    }
  },
  created () {
    OneChat_RequestProfileData()
  },
  mounted() {
    window.addEventListener('oneChatProfileData', async (e) => {
      this.mamalist = e.detail
    })
  }
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/test5.vue